<div class="acc-order-details">

  <section>
    <section class="col-12 col-sm-12 col-md-12" class="collabortion-outlet">
      <div class="col-xs-4 col-sm-12 col-md-7">
        <h3 class="monograph-Title">
          {{'collaboration.internal'|cxTranslate}}
        </h3>
      </div>
      <hr class="hr-Style" />
      <div>
        <div class="panel-group" id="accr-new" *ngFor="let prod of collaborationData">
          <div class="panel panel-default">
            <div class="panel-heading">
              <div class="firstLevel-loc product-text-img">
                <a href="{{prod?.fileMediaUrl}}" target="_blank" class="pdf-Style" data-di-id="di-id-61494698-8d975ab0">
                  <label class="prod-Name">{{ prod?.name}}</label>
                  <span *ngIf="prod?.fileFormat === 'pdf'">
                    <img src="..\..\assets\icons\pdf.png" alt="pdf" />Pdf</span>
                  <span *ngIf="prod?.fileFormat === 'pptx'">
                    <img src="..\..\assets\icons\ppt.png" alt="ppt" />
                    Pptx </span>
                  <span *ngIf="prod?.fileFormat === 'xlsx'|| prod?.fileFormat === 'xlsb'">
                    <img src="..\..\assets\icons\xl.png" alt="excel" />
                    <spn *ngIf="prod?.fileFormat === 'xlsx'">Xlsx</spn>
                    <span *ngIf="prod?.fileFormat === 'xlsb'">Xlsb</span>
                  </span>
                  <span *ngIf="prod?.fileFormat === 'doc'">
                    <img src="..\..\assets\icons\word.png" alt="excel" />
                    Doc</span>
                </a>
                <div class="sub-text">{{ prod?.description}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</div>